import mobileMenu from "../modules/navMenuMobile";
import navMenu from "../modules/navMenu";

const desktopMenu = document.querySelector('.js-desktop-menu');
if (desktopMenu) new navMenu(desktopMenu);

new mobileMenu();

// const megaMenuIndicators = document.querySelectorAll('.js-menu-item-arrow')
// megaMenuIndicators.forEach(x => {
// 	x.innerHTML = `<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="caret-down" alt="" role="img" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 320 512"><path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>`
// });
